
<div>
  <b-button-toolbar class="justify-content-center my-3">
    <b-button-group class="mr-3">
      <b-button variant="danger" @click="updateProduct"> Add To Quote</b-button>
    </b-button-group>
    <b-button-group>
      <b-button variant="link" @click="goBack"> Cancel</b-button>
    </b-button-group>
  </b-button-toolbar>
</div>
